import { render, staticRenderFns } from "./Finance-account.vue?vue&type=template&id=18316ffc&"
import script from "./Finance-account.vue?vue&type=script&lang=js&"
export * from "./Finance-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports